module.exports = __webpack_public_path__ + "static/media/c-img.7d3159e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c-img.svg
// module id = 529
// module chunks = 0